<template>
  <i-card-vertical headerTitle="" device="multi" :IsUseSearchRequirement="false" style="padding: 5px;">
    <template v-slot:body>
      <v-layout column>
        <v-row>
          <v-col cols="12" lg="12" class="pa-0">
            <DxDataGrid
              :data-source="clntList"
              :hover-state-enabled="true"
              :focused-row-enabled="true"
              :width="width"
              :height="height"
              :word-wrap-enabled="true"
              :show-row-lines="true"
              :editing="{ allowUpdating: false }"
              :selection="{ mode: multiple ? 'multiple' : 'single', deferred: false }"
              :filter-row="{ visible: false }"
              :on-content-ready="() => {}"
              key-expr="clntId"
              @selection-changed="e => onGridSelectionChanged(e)"
              :on-initialized="() => null"
            >
              <DxPaging :enabled="true" :page-size="10" />
              <DxColumn data-field="clntNm" caption="고객사명" width="40%" />
              <DxColumn data-field="addrs1" caption="주소" width="60%" />
            </DxDataGrid>
          </v-col>
        </v-row>
      </v-layout>
    </template>
  </i-card-vertical>
</template>
<script>
import { getClientLeaderList } from '@/api/setting/clientManage'
import { getClientList } from '@/api/setting/clientManage'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가 및 권한 처리
  name: 'ClientSelectGridUser',
  props: {
    width: {
      //datePicker의 선택가능한 최대날짜 설정
      type: String,
      default: () => {
        return '100%'
      }
    },
    height: {
      type: String,
      default: () => {
        return '300px'
      }
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      clntList: [], // 고객사 리스트
      selectedClntInfo: '' // 선택된 고객사 ID
    }
  },
  mounted() {
    this.searchClient()
  },
  methods: {
    searchClient() {
      // getClientLeaderList({ clntId: this.getClntId() }).then(res => {
      //   this.clntList = res.list
      // })
      getClientList({ clntId: this.getClntId() }).then(res => {
        this.clntList = res.list
      })
    },
    onGridSelectionChanged(e) {
      this.selectedClntInfo = e.selectedRowsData[0]
      this.$emit('selectedData', this.selectedClntInfo)
    }
  }
}
</script>
